var $f692c6bcabd26695$exports = {};
$f692c6bcabd26695$exports = {
    "dismiss": `Dispensar`
};


export {$f692c6bcabd26695$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
